import { getCookie } from './browser';

export const getMagentoFormKey = () => {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV !== 'production') {
      resolve('fakeformkey');
    }
    if (window.__FORM_KEY_SET__) {
      resolve(getCookie('form_key'));
    }
    document.addEventListener('formKeySet', () => {
      resolve(getCookie('form_key'));
    });
  });
};



// WEBPACK FOOTER //
// ./src/helpers/formKey.js